import { useCallback, useEffect, useRef, useState } from 'react';
import { assetQuery, sanityFetch } from '../services/sanity';
import { postEndpoint, Service } from '../services/aws';
export var SearchIndex;
(function (SearchIndex) {
    SearchIndex["All"] = "sc_prod*";
    SearchIndex["Astronauts"] = "sc_prod_astronauts";
    SearchIndex["Launches"] = "sc_prod_launches";
    SearchIndex["Articles"] = "sc_prod_articles";
    SearchIndex["Missions"] = "sc_prod_missions";
})(SearchIndex || (SearchIndex = {}));
// ---------- FUNCTIONS ----------
export const getSearchSuggestions = async (config) => {
    const suggestedSearches = await sanityFetch(config, `*[
    _type == "suggestedSearch"
    && !(_id in path("drafts.**"))
  ] | order(sortRank desc) ${suggestedSearchQuery}`);
    return suggestedSearches;
};
export const getSearchResults = async (config, search, index = SearchIndex.All, size = 20, offset = 0) => {
    return postEndpoint(config, Service.Elastic, 'search', {
        q: search,
        index,
        offset,
        size
    });
};
export const useSearch = (config, search, index = SearchIndex.All, pageSize = 20) => {
    const [isLoading, setIsLoading] = useState(false);
    const [total, setTotal] = useState(0);
    const [hasNextPage, setHasNextPage] = useState(false);
    const [results, setResults] = useState();
    const latestSearchTextRef = useRef('');
    useEffect(() => {
        latestSearchTextRef.current = search;
        let timeout;
        if (search && search.length >= 0) {
            timeout = setTimeout(() => {
                getSearchResults(config, search, index, pageSize)
                    .then((response) => {
                    if (search === latestSearchTextRef.current) {
                        setResults(response.results);
                        setHasNextPage(response.hasNextPage);
                        setTotal(response.total);
                        setIsLoading(false);
                    }
                })
                    .catch((error) => {
                    setResults([]);
                    setHasNextPage(false);
                    setTotal(0);
                    setIsLoading(false);
                    console.log({ error });
                });
            }, 150);
        }
        else {
            setResults([]);
            setHasNextPage(false);
            setTotal(0);
            setIsLoading(false);
        }
        return () => clearTimeout(timeout);
    }, [search, index, pageSize]);
    const getNextPage = useCallback(() => {
        if (isLoading || !hasNextPage) {
            return;
        }
        setIsLoading(true);
        getSearchResults(config, search, index, pageSize, results?.length || 0)
            .then((response) => {
            if (search === latestSearchTextRef.current) {
                setResults((results || []).concat(response.results));
                setHasNextPage(response.hasNextPage);
                setTotal(response.total);
                setIsLoading(false);
            }
        })
            .catch((error) => {
            setResults([]);
            setHasNextPage(false);
            setTotal(0);
            setIsLoading(false);
            console.log({ error });
        });
    }, [search, index, pageSize, results, isLoading, hasNextPage]);
    return {
        isLoading,
        results,
        total,
        hasNextPage,
        getNextPage
    };
};
export const performSearchQuery = async (config, query, offset = 0, size = 20, sort) => {
    return postEndpoint(config, Service.Elastic, 'query', {
        q: query,
        offset,
        size,
        sort
    });
};
// ---------- QUERIES ----------
export const suggestedSearchQuery = `{
  _id,
  _type,
  title,
  sortRank,
  sort,
  query,
  image ${assetQuery}
}`;
//# sourceMappingURL=search.js.map